export { default as checkForEnemy } from "./checkForEnemy";
